"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A UI control which displays a glyphicon which the user can treat as a button or link.
 * ## Events
 * Name | Arguments | Description
 * click | None. | Fired whenever the icon is clicked.
 * @module app/views/ActionView
 */
var s = require("underscore.string");
var React = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var ActionDispatcher_1 = require("../operations/ActionDispatcher");
/**
 * Initializes the control.
 * @param  {object} options The options hash.
 * @param {string} options.icon The icon to use. Available icons can be found at http://getbootstrap.com/components/#glyphicons. To use the "plus" icon, the value of this argument should be `"plus"`.
 * @param {string} options.href:'#' The URL for the underlying anchor tag.
 * @param  {string} options.tooltip-text    The tooltip text to display.
 * @param {string} options.tooltip-position:'left' The position of the tooltip text relative to the icon. Valid values are `'left'`, `'right'`, `'top'`, and `'bottom'`.
 * @param {object} [options.tooltip] An object specifying options for the tooltip.
 * @param {string} [options.tooltip.text] The tooltip text to display. Overrides `options['tooltip-text']` when used.
 * @param {string} [options.tooltip.position] The position of the tooltip text relative to the icon. Valid values are `'left'`, `'right'`, `'top'`, and `'bottom'`. Overrides `options['tooltip-position']` when used.
 */
var ActionView = /** @class */ (function (_super) {
    __extends(ActionView, _super);
    function ActionView(props) {
        return _super.call(this, props) || this;
    }
    ActionView.prototype.className = function () {
        var _s = s;
        var props = this.props;
        return "action-view " + _s.slugify(props.itemKey());
    };
    ActionView.prototype.tooltip = function () {
        var props = this.props;
        return React.createElement(react_bootstrap_1.Tooltip, { id: "action-tooltip" }, props.tooltipText);
    };
    ActionView.prototype.link = function () {
        var _this = this;
        var props = this.props;
        var style = {};
        if (props.icon == "remove") {
            style.color = "#a94442";
        }
        return (React.createElement("a", { style: style, className: this.className(), href: props.href, onClick: function () {
                _this.handleClick();
            } },
            React.createElement(react_bootstrap_1.Glyphicon, { glyph: props.icon })));
    };
    ActionView.prototype.handleClick = function () {
        ActionDispatcher_1.default.dispatch(this.props);
    };
    ActionView.prototype.render = function () {
        var props = this.props;
        if (props.tooltipText) {
            return (React.createElement(react_bootstrap_1.OverlayTrigger, { placement: props.tooltipPosition, overlay: this.tooltip() }, this.link()));
        }
        else {
            return this.link();
        }
    };
    return ActionView;
}(React.Component));
exports.default = ActionView;
//# sourceMappingURL=ActionView.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/ActionView.js
// module id = 672
// module chunks = 1